import { BASE_URL } from '../../../Constant';

export const API_GET_ALL_DOCUMENT_TEMPLATES: string = `${BASE_URL}/document/template`;
export const API_DELETE_DOCUMENT_TEMPLATE: string = `${BASE_URL}/document/template`;
export const API_CREATE_DOCUMENT_TEMPLATE: string = `${BASE_URL}/document/template`;
export const API_UPDATE_DOCUMENT_TEMPLATE: string = `${BASE_URL}/document/template`;

export const DOCUMENT_TEMPLATE_STATUS_ACTIVE: number = 1;
export const DOCUMENT_TEMPLATE_STATUS_INACTIVE: number = 2;
export const DOCUMENT_TEMPLATE_STATUS_DELETED: number = 10;
